/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ActivityChildRecord } from '../model/activityChildRecord';
import { ActivityCreate } from '../model/activityCreate';
import { ActivityLookup } from '../model/activityLookup';
import { ActivityRead } from '../model/activityRead';
import { ActivityUpdate } from '../model/activityUpdate';
import { PaginatedActivityReadList } from '../model/paginatedActivityReadList';
import { PatchedActivityUpdate } from '../model/patchedActivityUpdate';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ChildPortfolioActivitiesService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Ordering fields: is_favorite, created, modified, title, annotated_group_record_count
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioActivitiesCreate(body: ActivityCreate, observe?: 'body', reportProgress?: boolean): Observable<ActivityCreate>;
    public childPortfolioActivitiesCreate(body: ActivityCreate, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivityCreate>>;
    public childPortfolioActivitiesCreate(body: ActivityCreate, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivityCreate>>;
    public childPortfolioActivitiesCreate(body: ActivityCreate, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling childPortfolioActivitiesCreate.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ActivityCreate>('post',`${this.basePath}/child-portfolio/activities/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering fields: is_favorite, created, modified, title, annotated_group_record_count
     * @param id A UUID string identifying this Aktivita.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioActivitiesDestroy(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public childPortfolioActivitiesDestroy(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public childPortfolioActivitiesDestroy(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public childPortfolioActivitiesDestroy(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling childPortfolioActivitiesDestroy.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/child-portfolio/activities/${encodeURIComponent(String(id))}/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering fields: is_favorite, created, modified, title, annotated_group_record_count
     * @param competenceCategories Více hodnot lze oddělit čárkami.
     * @param competencies 
     * @param createdBy 
     * @param groupUuid 
     * @param isFavorite 
     * @param isFirstLevelRecommended 
     * @param isSecondLevelRecommended 
     * @param isThirdLevelRecommended 
     * @param limit Number of results to return per page.
     * @param literacies 
     * @param offset The initial index from which to return the results.
     * @param ordering Which field to use when ordering the results.
     * @param search A search term.
     * @param skillAreas Více hodnot lze oddělit čárkami.
     * @param skillSubareas Více hodnot lze oddělit čárkami.
     * @param skills 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioActivitiesList(competenceCategories?: Array<string>, competencies?: Array<string>, createdBy?: number, groupUuid?: string, isFavorite?: string, isFirstLevelRecommended?: boolean, isSecondLevelRecommended?: boolean, isThirdLevelRecommended?: boolean, limit?: number, literacies?: Array<string>, offset?: number, ordering?: string, search?: string, skillAreas?: Array<string>, skillSubareas?: Array<string>, skills?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<PaginatedActivityReadList>;
    public childPortfolioActivitiesList(competenceCategories?: Array<string>, competencies?: Array<string>, createdBy?: number, groupUuid?: string, isFavorite?: string, isFirstLevelRecommended?: boolean, isSecondLevelRecommended?: boolean, isThirdLevelRecommended?: boolean, limit?: number, literacies?: Array<string>, offset?: number, ordering?: string, search?: string, skillAreas?: Array<string>, skillSubareas?: Array<string>, skills?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedActivityReadList>>;
    public childPortfolioActivitiesList(competenceCategories?: Array<string>, competencies?: Array<string>, createdBy?: number, groupUuid?: string, isFavorite?: string, isFirstLevelRecommended?: boolean, isSecondLevelRecommended?: boolean, isThirdLevelRecommended?: boolean, limit?: number, literacies?: Array<string>, offset?: number, ordering?: string, search?: string, skillAreas?: Array<string>, skillSubareas?: Array<string>, skills?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedActivityReadList>>;
    public childPortfolioActivitiesList(competenceCategories?: Array<string>, competencies?: Array<string>, createdBy?: number, groupUuid?: string, isFavorite?: string, isFirstLevelRecommended?: boolean, isSecondLevelRecommended?: boolean, isThirdLevelRecommended?: boolean, limit?: number, literacies?: Array<string>, offset?: number, ordering?: string, search?: string, skillAreas?: Array<string>, skillSubareas?: Array<string>, skills?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

















        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (competenceCategories) {
            queryParameters = queryParameters.set('competence_categories', competenceCategories.join(COLLECTION_FORMATS['csv']));
        }
        if (competencies) {
            competencies.forEach((element) => {
                queryParameters = queryParameters.append('competencies', <any>element);
            })
        }
        if (createdBy !== undefined && createdBy !== null) {
            queryParameters = queryParameters.set('created_by', <any>createdBy);
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }
        if (isFavorite !== undefined && isFavorite !== null) {
            queryParameters = queryParameters.set('is_favorite', <any>isFavorite);
        }
        if (isFirstLevelRecommended !== undefined && isFirstLevelRecommended !== null) {
            queryParameters = queryParameters.set('is_first_level_recommended', <any>isFirstLevelRecommended);
        }
        if (isSecondLevelRecommended !== undefined && isSecondLevelRecommended !== null) {
            queryParameters = queryParameters.set('is_second_level_recommended', <any>isSecondLevelRecommended);
        }
        if (isThirdLevelRecommended !== undefined && isThirdLevelRecommended !== null) {
            queryParameters = queryParameters.set('is_third_level_recommended', <any>isThirdLevelRecommended);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (literacies) {
            literacies.forEach((element) => {
                queryParameters = queryParameters.append('literacies', <any>element);
            })
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (skillAreas) {
            queryParameters = queryParameters.set('skill_areas', skillAreas.join(COLLECTION_FORMATS['csv']));
        }
        if (skillSubareas) {
            queryParameters = queryParameters.set('skill_subareas', skillSubareas.join(COLLECTION_FORMATS['csv']));
        }
        if (skills) {
            skills.forEach((element) => {
                queryParameters = queryParameters.append('skills', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PaginatedActivityReadList>('get',`${this.basePath}/child-portfolio/activities/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering fields: is_favorite, created, modified, title, annotated_group_record_count
     * @param competenceCategories Více hodnot lze oddělit čárkami.
     * @param competencies 
     * @param createdBy 
     * @param groupUuid 
     * @param isFavorite 
     * @param isFirstLevelRecommended 
     * @param isSecondLevelRecommended 
     * @param isThirdLevelRecommended 
     * @param literacies 
     * @param ordering Which field to use when ordering the results.
     * @param search A search term.
     * @param skillAreas Více hodnot lze oddělit čárkami.
     * @param skillSubareas Více hodnot lze oddělit čárkami.
     * @param skills 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioActivitiesLookupList(competenceCategories?: Array<string>, competencies?: Array<string>, createdBy?: number, groupUuid?: string, isFavorite?: string, isFirstLevelRecommended?: boolean, isSecondLevelRecommended?: boolean, isThirdLevelRecommended?: boolean, literacies?: Array<string>, ordering?: string, search?: string, skillAreas?: Array<string>, skillSubareas?: Array<string>, skills?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<ActivityLookup>>;
    public childPortfolioActivitiesLookupList(competenceCategories?: Array<string>, competencies?: Array<string>, createdBy?: number, groupUuid?: string, isFavorite?: string, isFirstLevelRecommended?: boolean, isSecondLevelRecommended?: boolean, isThirdLevelRecommended?: boolean, literacies?: Array<string>, ordering?: string, search?: string, skillAreas?: Array<string>, skillSubareas?: Array<string>, skills?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ActivityLookup>>>;
    public childPortfolioActivitiesLookupList(competenceCategories?: Array<string>, competencies?: Array<string>, createdBy?: number, groupUuid?: string, isFavorite?: string, isFirstLevelRecommended?: boolean, isSecondLevelRecommended?: boolean, isThirdLevelRecommended?: boolean, literacies?: Array<string>, ordering?: string, search?: string, skillAreas?: Array<string>, skillSubareas?: Array<string>, skills?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ActivityLookup>>>;
    public childPortfolioActivitiesLookupList(competenceCategories?: Array<string>, competencies?: Array<string>, createdBy?: number, groupUuid?: string, isFavorite?: string, isFirstLevelRecommended?: boolean, isSecondLevelRecommended?: boolean, isThirdLevelRecommended?: boolean, literacies?: Array<string>, ordering?: string, search?: string, skillAreas?: Array<string>, skillSubareas?: Array<string>, skills?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {















        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (competenceCategories) {
            queryParameters = queryParameters.set('competence_categories', competenceCategories.join(COLLECTION_FORMATS['csv']));
        }
        if (competencies) {
            competencies.forEach((element) => {
                queryParameters = queryParameters.append('competencies', <any>element);
            })
        }
        if (createdBy !== undefined && createdBy !== null) {
            queryParameters = queryParameters.set('created_by', <any>createdBy);
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }
        if (isFavorite !== undefined && isFavorite !== null) {
            queryParameters = queryParameters.set('is_favorite', <any>isFavorite);
        }
        if (isFirstLevelRecommended !== undefined && isFirstLevelRecommended !== null) {
            queryParameters = queryParameters.set('is_first_level_recommended', <any>isFirstLevelRecommended);
        }
        if (isSecondLevelRecommended !== undefined && isSecondLevelRecommended !== null) {
            queryParameters = queryParameters.set('is_second_level_recommended', <any>isSecondLevelRecommended);
        }
        if (isThirdLevelRecommended !== undefined && isThirdLevelRecommended !== null) {
            queryParameters = queryParameters.set('is_third_level_recommended', <any>isThirdLevelRecommended);
        }
        if (literacies) {
            literacies.forEach((element) => {
                queryParameters = queryParameters.append('literacies', <any>element);
            })
        }
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (skillAreas) {
            queryParameters = queryParameters.set('skill_areas', skillAreas.join(COLLECTION_FORMATS['csv']));
        }
        if (skillSubareas) {
            queryParameters = queryParameters.set('skill_subareas', skillSubareas.join(COLLECTION_FORMATS['csv']));
        }
        if (skills) {
            skills.forEach((element) => {
                queryParameters = queryParameters.append('skills', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ActivityLookup>>('get',`${this.basePath}/child-portfolio/activities/lookup/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering fields: is_favorite, created, modified, title, annotated_group_record_count
     * @param id A UUID string identifying this Aktivita.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioActivitiesPartialUpdate(id: string, body?: PatchedActivityUpdate, observe?: 'body', reportProgress?: boolean): Observable<ActivityRead>;
    public childPortfolioActivitiesPartialUpdate(id: string, body?: PatchedActivityUpdate, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivityRead>>;
    public childPortfolioActivitiesPartialUpdate(id: string, body?: PatchedActivityUpdate, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivityRead>>;
    public childPortfolioActivitiesPartialUpdate(id: string, body?: PatchedActivityUpdate, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling childPortfolioActivitiesPartialUpdate.');
        }


        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ActivityRead>('patch',`${this.basePath}/child-portfolio/activities/${encodeURIComponent(String(id))}/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering fields: is_favorite, created, modified, title, annotated_group_record_count
     * @param id A UUID string identifying this Aktivita.
     * @param groupUuid Filter by group UUID. If provided, only children in this group will be returned.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioActivitiesRelatedChildrenList(id: string, groupUuid?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ActivityChildRecord>>;
    public childPortfolioActivitiesRelatedChildrenList(id: string, groupUuid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ActivityChildRecord>>>;
    public childPortfolioActivitiesRelatedChildrenList(id: string, groupUuid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ActivityChildRecord>>>;
    public childPortfolioActivitiesRelatedChildrenList(id: string, groupUuid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling childPortfolioActivitiesRelatedChildrenList.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ActivityChildRecord>>('get',`${this.basePath}/child-portfolio/activities/${encodeURIComponent(String(id))}/related-children/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering fields: is_favorite, created, modified, title, annotated_group_record_count
     * @param id A UUID string identifying this Aktivita.
     * @param groupUuid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioActivitiesRetrieve(id: string, groupUuid?: string, observe?: 'body', reportProgress?: boolean): Observable<ActivityRead>;
    public childPortfolioActivitiesRetrieve(id: string, groupUuid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivityRead>>;
    public childPortfolioActivitiesRetrieve(id: string, groupUuid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivityRead>>;
    public childPortfolioActivitiesRetrieve(id: string, groupUuid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling childPortfolioActivitiesRetrieve.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ActivityRead>('get',`${this.basePath}/child-portfolio/activities/${encodeURIComponent(String(id))}/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering fields: is_favorite, created, modified, title, annotated_group_record_count
     * @param body 
     * @param id A UUID string identifying this Aktivita.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioActivitiesUpdate(body: ActivityUpdate, id: string, observe?: 'body', reportProgress?: boolean): Observable<ActivityRead>;
    public childPortfolioActivitiesUpdate(body: ActivityUpdate, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivityRead>>;
    public childPortfolioActivitiesUpdate(body: ActivityUpdate, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivityRead>>;
    public childPortfolioActivitiesUpdate(body: ActivityUpdate, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling childPortfolioActivitiesUpdate.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling childPortfolioActivitiesUpdate.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ActivityRead>('put',`${this.basePath}/child-portfolio/activities/${encodeURIComponent(String(id))}/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
